// extracted by mini-css-extract-plugin
export default {"root":"FqhA1__root"};